import commandReducer from './slice';

export default commandReducer;
